// Хук useStaffEvents: подписка на SSE /api/staff/events и инвалидация react-query-кэшей.
// Все страницы вешают один провайдер в AppShell; конкретные компоненты не знают о SSE.
//
// Стратегия инвалидации: тип события → массив query-keys (компактно, без переусложнения).
// При отсутствии сети или 401 EventSource автоматически ретраит; закрываем при unmount.

import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const EVENT_TO_QUERIES: Record<string, ReadonlyArray<readonly string[]>> = {
  'escalation.created': [['clients'], ['sessions'], ['attention']],
  'escalation.closed': [['clients'], ['sessions'], ['attention']],
  'draft.created': [['drafts'], ['attention']],
  'draft.handled': [['drafts'], ['attention']],
  'booking.upserted': [['bookings']],
  'message.appended': [['clients'], ['sessions']],
  'source.health': [['integrations']],
  'attention.count': [['attention']],
};

export function useStaffEvents(): void {
  const qc = useQueryClient();

  useEffect(() => {
    // EventSource автопереконнект на разрыв. При 401 после logout - редирект случится
    // при следующем query (не здесь), чтобы не устраивать race с router.
    const es = new EventSource('/api/staff/events');
    const onEvent = (type: string) => (e: MessageEvent) => {
      const targets = EVENT_TO_QUERIES[type];
      if (!targets) return;
      for (const key of targets) {
        void qc.invalidateQueries({ queryKey: key as unknown as string[] });
      }
      // Debug: e.data - JSON.stringify(StaffEvent), пригодится в consuming-компонентах через custom hook.
      void e;
    };
    // Nest @Sse кладёт .type в event-name; регистрируем под каждый.
    Object.keys(EVENT_TO_QUERIES).forEach((t) => es.addEventListener(t, onEvent(t)));

    es.onerror = () => {
      // Молча ретраим - браузер сделает reconnect сам. В консоли не спамим.
    };

    return () => {
      es.close();
    };
  }, [qc]);
}
